const initState = {
    themeId: 1,
}

type ThemeState = typeof initState

export const themeReducer = (state = initState, action: ThemeAction): ThemeState => { // fix any
    switch (action.type) {
        case 'SET_THEME_ID':
            return {
                ...state,
                themeId: action.id,
            }
        // дописать

        default:
            return state
    }
}
type ThemeAction = ReturnType<typeof changeThemeId>

export const changeThemeId = (id: number) => ({ type: 'SET_THEME_ID' , id } as const) // fix any
